module.exports = __webpack_public_path__ + "static/media/customermdm.f23a8cfd.gif";